<template>
  <div class="box">
    <div class="top">
      <div class="avatar">
        <el-avatar :size="50" :src="user.avatar" />
      </div>
      <div>
        <div class="userName">{{ user.name }}</div>
        <div class="phone" v-if="authType==='allAuth'">{{ user.company?.name }}</div>
        <div class="phone" v-else>暂无公司</div>
      </div>
      <!-- <AuthIcon iconType class="AuthIcon" /> -->
      <img src="@/assets/image/home/unAuth.webp" v-if="authType === 'unAuth'" class="AuthIcon" @click="AuthIconClick">
      <img src="@/assets/image/home/unCompanyAuth.webp" v-if="authType === 'unCompanyAuth'" class="AuthIcon" @click="AuthIconClick">
      <img src="@/assets/image/home/allAuth.webp" v-if="authType === 'allAuth'" class="AuthIcon">

    </div>
    <div class="panel">
      <div class="panel_item" @click="toYue">
        <div class="panel_t">余额 <i class="el-icon-arrow-right"></i></div>
        <div class="panel_b">¥{{ utils.priceFormat(user.balance) }}</div>
      </div>
      <div class="panel_item" @click="toDaijinquan">
        <div class="panel_t">代金劵 <i class="el-icon-arrow-right"></i></div>
        <div class="panel_b">{{ user.voucherCount }}</div>
      </div>
      <div class="panel_item" @click="toTuiguangshouyi">
        <div class="panel_t">推广收益 <i class="el-icon-arrow-right"></i></div>
        <div class="panel_b">¥{{ utils.priceFormat(user.reward) }}</div>
      </div>
    </div>
    <div class="button" @click="toQianshu">
      <img class="icon" src="@/assets/image/home/add.png" alt="" srcset="" />
      <p class="text">点击上传</p>
      <el-button type="primary" class="btn">发起签署</el-button>
    </div>
  </div>
</template>

<script>
import userinfo from "@/mixins/userinfo";
import utils from "@/utils/utils";
// import AuthIcon from "@/components/AuthIcon/index.vue";
export default {
  name: "user-profile",
  mixins: [userinfo],
  // components: { AuthIcon },
  data() {
    return {
      utils,
    };
  },
  mounted() {},
  computed: {},
  methods: {
    async toYue() {
      await this.verifyUserAuth();
      this.$router.push({ path: "/accountCenter/balance/recharge" });
    },
    async toDaijinquan() {
      await this.verifyUserAuth();
      this.$router.push({ path: "/accountCenter/voucher" });
    },
    async toTuiguangshouyi() {
      await this.verifyUserAuth();
      this.$router.push({ path: "/accountCenter/promotion" });
    },
    async toQianshu() {
      await this.verifyUserAuth();
      await this.verifyCompanyAuth();
      this.$router.push({ path: "/hetongqianshu" });
    },
    async AuthIconClick() {
        await this.verifyUserAuth();
      await this.verifyCompanyAuth();
    }
  },
};
</script>

<style scoped lang="scss">
.box {
  width: 100%;
  height: 307px;
  border-radius: $border-radius;
  background: #66f;

  height: 307px;
  border-radius: 4px;
  opacity: 1;

  /* 自动布局 */

  background: rgba(255, 255, 255, 0.4);

  box-sizing: border-box;
  border: 1px solid #ffffff;

  backdrop-filter: blur(4px);
  padding-top: 10px;
   position: relative;
  .top {
    height: 66px;

    /* 自动布局 */
    display: flex;
    padding-left: 16px;
    align-items: center;
    gap: 12px;
   
    .userName {
      line-height: 23px;
      font-size: 16px;
      color: #262626;
      font-family: "Noto Sans SC";
    }
    .phone {
      line-height: 17px;
      font-family: "Noto Sans SC";
      font-size: 12px;
      color: #999999;
    }
    .AuthIcon {
      position: absolute;
      right: -1px;
      top: -1px;
      width: 78px;
      height: 22px;
      cursor: pointer;
    }
  }
  .panel {
    display: flex;
    gap: 3px;
    &_item {
      width: 100%;
      padding-left: 16px;
      display: flex;
      flex-direction: column;
      gap: 4px;
      height: 64px;
      justify-content: center;
      cursor: pointer;
    }
    &_t {
      height: 17px;
      display: flex;
      align-items: center;
      font-family: "Noto Sans SC";
      font-size: 12px;
      font-weight: 400;
      color: #999999;
    }
    &_b {
      height: 23px;

      font-family: "Noto Sans SC";
      font-size: 20px;
      font-weight: bold;
      font-variation-settings: "opsz" auto;
      color: #3d3d3d;
    }
  }
  .button {
    width: 296px;
    height: 141px;
    border-radius: 4px;
    opacity: 1;

    /* 自动布局 */
    display: flex;
    flex-direction: undefined;
    justify-content: undefined;
    align-items: undefined;
    padding: NaNpx;

    background: rgba(0, 98, 255, 0.05);

    box-sizing: border-box;
    border: 1px dashed #0062ff;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    .icon {
      margin: 0 auto;
      margin-top: 30px;
      height: 17px;
      opacity: 1;

      font-size: 12px;

      font-feature-settings: "kern" on;
      color: #666666;
    }
    .text {
      margin: 0 auto;
      margin-top: 4px;
      height: 17px;

      font-family: "Noto Sans SC";
      font-size: 12px;
      color: #666666;
    }
    .btn {
      width: 264px;
      height: 40px;
      border-radius: 4px;
      margin: 0 auto;
      margin-top: 16px;
    }
  }
}
</style>
